import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { RouterConfig } from "../../../config";
import "./rules.scss";


const Rules = () => {
    const dataNavlink = [
        { id: 1, link: RouterConfig.rules.introduce.route, name: RouterConfig.rules.introduce.name },
        { id: 2, link: RouterConfig.rules.explainWords.route, name: RouterConfig.rules.explainWords.name },
        { id: 3, link: RouterConfig.rules.generalTerms.route, name: RouterConfig.rules.generalTerms.name },
        { id: 4, link: RouterConfig.rules.detailedTerms.route, name: RouterConfig.rules.detailedTerms.name },
    ]
    return (
        <div className='rules'>
            <div className="link">
                {
                    dataNavlink.map(value => {
                        return (
                            <div className="item"   key={value.id}>
                                <NavLink
                                    to={value.link}
                                    className={({ isActive }) =>
                                        isActive ? 'activeClassName' : undefined
                                    }
                                >
                                    <div className="text">{value.name}</div>
                                </NavLink>
                            </div>

                        )
                    })
                }
            </div>
            <div className="contentPolicy"><Outlet /></div>
        </div>
    );
};

Rules.propTypes = {
};

export default Rules;
